import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarBookIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      d="M15 1.67H6.67A3.33 3.33 0 0 0 3.33 5v10a3.33 3.33 0 0 0 3.34 3.33H15a1.67 1.67 0 0 0 1.67-1.66V3.33A1.67 1.67 0 0 0 15 1.67ZM5 5a1.67 1.67 0 0 1 1.67-1.67H15v8.34H6.67c-.6 0-1.17.16-1.67.46V5Zm1.67 11.67a1.67 1.67 0 1 1 0-3.34H15v3.34H6.67Zm1.66-10h3.34a.83.83 0 1 0 0-1.67H8.33a.83.83 0 1 0 0 1.67Z"
      fill="#5C64ED"
    />
    <path
      d="M15 1.67H6.67A3.33 3.33 0 0 0 3.33 5v10a3.33 3.33 0 0 0 3.34 3.33H15a1.67 1.67 0 0 0 1.67-1.66V3.33A1.67 1.67 0 0 0 15 1.67ZM5 5a1.67 1.67 0 0 1 1.67-1.67H15v8.34H6.67c-.6 0-1.17.16-1.67.46V5Zm1.67 11.67a1.67 1.67 0 1 1 0-3.34H15v3.34H6.67Zm1.66-10h3.34a.83.83 0 1 0 0-1.67H8.33a.83.83 0 1 0 0 1.67Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="10"
        y1="1.67"
        x2="10"
        y2="18.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9445EC" />
        <stop offset="1" stopColor="#2782ED" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarBookIcon.defaultProps = {
  sx: null,
}
